import { useContext } from "react";

import { HarvestSheetContext } from "./Context";

const useHarvestSheet = () => {
  const context = useContext(HarvestSheetContext);

  if (!context) {
    throw new Error("useHarvestSheet must be used within a HarvestSheetProvider");
  }

  return context;
};

export default useHarvestSheet;
